/** @jsx jsx */
/* eslint-disable no-use-before-define,jsx-a11y/anchor-is-valid */
import { jsx } from '@emotion/core'
import { sectionCss } from './style'
import React from 'react'
import { openWindow } from '../twd'
export default ({dataName='knowledge-center'} = {}) => (
    <React.Fragment>
    <div className="vertical-offset-sm"></div>
    <div data-name={dataName} className="container vertical-offset-sm" css={sectionCss}>
        <div className="row vertical-offset-sm"></div>

        <div className="row">
            <div className="col-md-4 col-xs-4">
            <div style={{marginTop:"-20px"}}>
                <i className="et-icon et-icon-xl et-graduation-gift" aria-hidden="true"></i>
            </div>
            </div>
            <div className="col-md-8 col-xs-8">
                <h4>Looking to expand your fixed income knowledge?</h4>
                <a href='#'
                    data-name={dataName + '-library-link'}
                    style={{cursor:'pointer'}}
                    onClick={() => openWindow('https://us.etrade.com/knowledge/library/bonds-cds')}
                    >Explore our bond investing library</a>
            </div>
        </div>

        <div className="row vertical-offset-sm"></div>

    </div>
    </React.Fragment>
)
